import { AndroidCallbackPage } from "@js/pages/android-callback";
import { IosAuthFinishPage } from "@js/pages/ios-auth-finish";
import type { Page } from "@js/pages/types";

const OUTLET_ID = "kdl-app-outlet";
const DEEPLINK_ROUTE_CLASS = "kdl-route--deeplink";

const routes: Record<string, Page> = {
  [`/ios/${import.meta.env.VITE_BUNDLE_IDENTIFIER}/auth/finish`]: new IosAuthFinishPage(),
  [`/android/${import.meta.env.VITE_BUNDLE_IDENTIFIER}/callback`]: new AndroidCallbackPage(),
};

class Router {
  #outlet: HTMLElement | null = null;
  #currentPage: Page | null = null;
  #pathname: string = "";

  constructor() {
    this.handleRouteChange = this.handleRouteChange.bind(this);
  }

  get pathname(): string {
    return this.#pathname;
  }

  isLandingRoute(): boolean {
    return !Object.hasOwn(routes, this.#pathname);
  }

  init() {
    this.#outlet = document.getElementById(OUTLET_ID);

    if (this.#outlet === null) {
      throw new Error(`Router outlet element #${OUTLET_ID} was not found`);
    }

    this.handleRouteChange();
    window.addEventListener("popstate", this.handleRouteChange);
  }

  destroy() {
    window.removeEventListener("popstate", this.handleRouteChange);
    this.#destroyCurrentPage();
  }

  handleRouteChange() {
    this.#pathname = window.location.pathname;
    this.#renderRoute();
  }

  #renderRoute() {
    this.#destroyCurrentPage();

    if (this.isLandingRoute()) {
      document.body.classList.remove(DEEPLINK_ROUTE_CLASS);
      this.#outlet?.replaceChildren();
      this.#outlet?.setAttribute("hidden", "");
      return;
    }

    document.body.classList.add(DEEPLINK_ROUTE_CLASS);
    this.#outlet?.removeAttribute("hidden");

    if (this.#outlet === null) {
      return;
    }

    this.#currentPage = routes[this.#pathname];
    this.#currentPage.mount(this.#outlet);
  }

  #destroyCurrentPage() {
    this.#currentPage?.destroy?.();
    this.#currentPage = null;
  }
}

export { Router };
